import { connect } from 'react-redux';
import { Dispatch, IAppState } from '../../../../common/state';
import { SummarySortDropdown, ISortDropdownProps } from '../../../components/Summary';
import { ESortValue } from '../../../../repositories/common/json_query';
import { changeSort } from '../../../../filters/state/sort';
import { isRedesignExperimentEnabled } from '../../../../selectors/isRedesignExperimentEnabled';

export function mapStateToProps(
  state: IAppState,
): Pick<ISortDropdownProps, 'currentLocation' | 'jsonQuery' | 'isRedesignEnabled'> {
  return {
    currentLocation: state.filters.currentLocation,
    jsonQuery: state.results.jsonQuery,
    isRedesignEnabled: isRedesignExperimentEnabled(state),
  };
}

export function mapDispatchToProps(dispatch: Dispatch): Pick<ISortDropdownProps, 'onSortChanged'> {
  return {
    onSortChanged: (sort: ESortValue) => {
      dispatch(changeSort(sort));
    },
  };
}

export const SummarySortDropdownContainer = connect(mapStateToProps, mapDispatchToProps)(SummarySortDropdown);
